/* eslint-disable func-names, no-var, func-style */
var dayjs = require('dayjs');
var AdvancedFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(AdvancedFormat); // for using 'Do, in formatting date

/**
 * @class ScheduledDownTime
 * @param {string} willUpString - in format DD/MM/YYYY hh:mm
 */
module.exports = function(willUpString) {

  var downUntil;

  // settings
  var maxHoursToShowOnlyTime = 12;
  var downtimeText = window.translate.svs_scheduled_downtime;

  var getCurrentTime = function() {
    return dayjs();
  };

  var getHoursBetween = function(date1, date2) {
    var milliseconds = date1.diff(date2);
    return milliseconds / 1000 / 60 / 60;
  };

  var getIntelligentUpTime = function(date) {
    var dateFormat =
      getHoursBetween(date, getCurrentTime()) < maxHoursToShowOnlyTime ? 'h:mm a' : 'MMM Do h:mm a';
    return date.format(dateFormat);
  };

  var scheduledDownTime = {
    updateDowntimeText: function(downtimeText) {
      downUntil = dayjs(downtimeText.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')); // replace converts 'DD/MM/YYYY hh:mm' to 'YYYY-MM-DD hh:mm'
    },
    getIntelligentUpTime: function() {
      return getIntelligentUpTime(downUntil);
    },
    getSentence: function() {
      return downtimeText.replace('[#TIME]', scheduledDownTime.getIntelligentUpTime());
    }
  };

  scheduledDownTime.updateDowntimeText(willUpString);

  return scheduledDownTime;
};
